import React, { useLayoutEffect } from 'react';
import {
    Grid,
    GridProps,
    Text,
} from '@chakra-ui/react';
import {
    Image,
    RichText,
    useAppDispath,
} from 'shared';
import { useParams } from 'react-router-dom';
import { CartAddButtonWithCounter, LeadSmallSection } from 'features';
// eslint-disable-next-line no-restricted-imports
import { Carousel } from 'shared/ui/Carousel';
import { Helmet } from 'react-helmet-async';
// eslint-disable-next-line no-restricted-imports
import { richTextToString } from 'shared/lib/richtext-to-string';
import { DeliveryArticlePageActions, useDeliveryArticlePageState } from '../../store';
import { DeliveryArticlePageMainHeader } from './DeliveryArticlePageMainHeader';
import { DeliveryArticlePageMainElementsSection } from './DeliveryArticlePageMainElementsSection';
import { DeliveryArticlePageMainRecommendationsSection } from './DeliveryArticlePageMainRecommendationsSection';

export type DeliveryArticlePageMainProps = GridProps & React.RefAttributes<HTMLDivElement>

export const DeliveryArticlePageMain: React.FC<DeliveryArticlePageMainProps> = ({
    ...props
}) => {
    const dispatch = useAppDispath();
    const { id } = useParams();
    const { deliveryArticle, leadFormPdf } = useDeliveryArticlePageState();

    useLayoutEffect(() => {
        if (id) {
            dispatch(DeliveryArticlePageActions.getDeliveryArticleByUid({
                uid: id,
            }));
        }
    }, [id]);

    return id ? (
        <Grid
            {...props}
        >
            <Helmet>
                <title>{deliveryArticle?.name}</title>
                <meta name="description" content={richTextToString(deliveryArticle?.description)} />
                <meta property="og:title" content={deliveryArticle?.name} />
            </Helmet>
            <DeliveryArticlePageMainHeader
                title={deliveryArticle?.name || ''}
                padding="2rem 2rem 0 2rem"
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                width="100%"
                margin="0 auto"
                gap="2rem"
                background="white"
            />
            <Grid
                templateColumns={{
                    base: '1fr',
                    lg: '1fr 1fr',
                }}
                padding="2rem"
                gap="2rem"
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                background="white"
                width="100%"
                margin="0 auto"
            >
                <Carousel
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    width="100%"
                    margin="0 auto"
                    background="white"
                    withDialog
                    items={deliveryArticle?.images?.map(({ url }) => (
                        <Image aspectRatio="1 / 1" width="100%" objectFit="cover" src={url} />
                    )) || []}
                />
                <Grid
                    gap="2rem"
                    templateRows="auto 1fr auto"
                >
                    <DeliveryArticlePageMainElementsSection
                        elements={deliveryArticle?.elements || []}
                    />
                    <RichText
                        content={deliveryArticle?.description}
                    />
                    <Grid
                        templateColumns="1fr auto"
                    >
                        <Grid>
                            <Text fontSize="1rem">
                                Вес:
                                {' '}
                                {deliveryArticle?.weight?.toLocaleString()}
                                г
                            </Text>
                            <Text fontSize="2rem" fontWeight={900}>
                                {deliveryArticle?.price?.toLocaleString()}
                                {deliveryArticle?.currency?.abbreviation}
                            </Text>
                        </Grid>
                        <CartAddButtonWithCounter
                            type="delivery"
                            uid={id}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                background="#000000"
            >
                <LeadSmallSection
                    title="НЕ МОЖЕТЕ ОПРЕДЕЛИТЬСЯ?"
                    padding="2rem"
                    buttonText="Заказать звонок"
                    background="#000000"
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    width="100%"
                    margin="0 auto"
                    pdfUrl={leadFormPdf?.url}
                />
            </Grid>
            {deliveryArticle?.recommendations && deliveryArticle?.recommendations.length > 0 && (
                <DeliveryArticlePageMainRecommendationsSection
                    padding="2rem"
                    deliveryArticleRecommendations={deliveryArticle.recommendations}
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    background="white"
                    width="100%"
                    margin="0 auto"
                />
            )}
        </Grid>
    ) : null;
};
